import { render, staticRenderFns } from "./ontick-lightweight-charts.component.vue?vue&type=template&id=2e419aa3"
import script from "./ontick-lightweight-charts.component.vue?vue&type=script&lang=js"
export * from "./ontick-lightweight-charts.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports